<template>
  <div>
    <div class="ucenter_mains_div">
      <div class="ucenter_mains_div_A">

        <div class="ucenter_mains_div_A_divS">
          <div class="ucenter_mains_div_A_divS_divs">

            <div class="ucenter_mains_div_A_divS_divs_div">
              <div class="ucenter_mains_div_A_divS_divs_div_divA">
                <div class="ucenter_mains_div_A_divS_divs_div_divA_img">
                  <img
                      src="http://apiupss.ppfly.top/images/liuliang.png"
                      alt=""
                  />
                  <div>账户余额：{{ userdata.balance }}</div>
                </div>
              </div>

              <div class="ucenter_mains_div_A_divS_divs_div_divA">
                <div class="ucenter_mains_div_A_divS_divs_div_divA_img" style="align-items: center">
                  <img
                      src="@/assets/images/ys_icon15.png"
                      style="width: 35px; height: 35px;"
                      alt=""
                  />
                  <div>账户密钥：{{ userdata.key ? userdata.key : "无" }}</div>
                  <div class="butt_ucenter_butts" style="margin-left: 30px" @click="user_reset_key()">
                    {{ userdata.key ? "重置密钥" : "生成密钥" }}
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>

      </div>

      <div class="ucenter_mains_div_B">
        <div class="ucenter_mains_div_B_divA">
          <div class="ucenter_mains_div_B_divA_div">
            <div>
              <div class="log_text">
                <img src="../../assets/logC.png" alt=""/>
              </div>
              <div class="log_user">
                <div class="ucenter_mains_div_B_divA_name">
                  {{ userdata.adminname }}
                </div>
                <div class="ucenter_mains_div_B_divA_ponth">
                  {{ userdata.phone }}
                </div>
                <div class="ucenter_mains_div_B_divA_type">
                  {{ userdata.type }}
                </div>
              </div>
            </div>
            <div class="ucenter_butts">
              <div class="butt_ucenter_butts" @click="toupdateuser()">
                修改密码
              </div>
              <div class="butt_ucenter_butts" @click="todengchu()">
                退出登录
              </div>
            </div>
            <div class="ucenter_div_text">
              <div class="ucenter_div_text_A">
                TIPS:为保证账号安全，请妥善保护您的账号密码。
              </div>
              <div class="ucenter_div_text_A">
                注：所有类型IP仅支持在境外网络环境下使用
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/requset/api";

export default {
  name: "ucenter_jbxx",
  data() {
    return {
      listdata: {},
      xData: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"], //横坐标
      yData: [23, 24, 18, 25, 27, 28, 25], //数据
      myChartStyle: {float: "left", width: "100%", height: "400px"}, //图表样式
      iframeSrc: '',
      userdata: {
        adminname: "",
        phone: "",
        type: "普通用户",
        balance: 0,
        key: "",
      },
    };
  },
  watch: {
    'userdata.adminname'(newVal) {
      this.updateIframeSrc(newVal);
    }
  },
  created() {
    const token = this.$cookies.get("userdata");
    if (token.data.user_data.Nickname) {
      this.userdata.adminname = token.data.user_data.Nickname;
      this.userdata.phone = token.data.user_data.Mobile.replace(
          /(\d{3})\d{4}(\d{4})/,
          "$1****$2"
      );
    }
    // 初始设置 iframe 地址
    this.updateIframeSrc(this.userdata.adminname);
  },
  mounted() {
    this.user_balance()
  },
  methods: {
    toupdateuser() {
      this.$router.push({path: "updateuser"});
    },
    todengchu() {
      this.$cookies.remove("userdata");
      this.$router.push({path: "/"});
    },
    user_balance() {
      api.user_balance({})
          .then((res) => {
            if (res.data.error_code != 0) {
              this.$message({
                message: res.data.message,
                type: "warning",
              });
              return
            }
            this.userdata.balance = res.data.data.balance
            this.userdata.key = res.data.data.key
          })
          .catch(() => {
          });
    },
    user_reset_key() {
      this.$confirm("确认是否" + (this.userdata.key ? "重置" : "生成") + "密钥", '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
        api.user_reset_key({})
            .then((res) => {
              if (res.data.error_code != 0) {
                this.$message({
                  message: res.data.message,
                  type: "warning",
                });
                return
              }
              this.$confirm(res.data.data, '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                closeOnClickModal: false, // 点击外部不会关闭
                closeOnPressEscape: false, // 按 ESC 也不会关闭（可选）
                type: "success",
              }).then(() => {
              }).catch(() => {
              }).finally(() => {
                this.user_balance()
              });
            })
            .catch(() => {
            });
      }).catch(() => {
      });
    },

  },
};
</script>
<style>
.ucenter {
  height: 100vh;
}
</style>
<style>
.ucenter_header {
  color: #333;
  background-color: #e4ebf7;
  text-align: center;
  /* height: 400px; */
  padding: 10px;
}

.el-aside {
  background-color: #1f2738;
  color: #333;
  text-align: center;
  height: 100vh;
  overflow-x: hidden;
}

.el-main {
  /* line-height: 160px; */
}

.ucenter_main {
  background-color: #e4ebf7;
  color: #333;
  text-align: center;
  overflow-y: auto;
  height: 90vh;
  text-align: center;
}

.ucenter_mains_div {
  margin: 10px;
  margin-top: 10px;
  /* height: 3000px; */
  background-color: #e4ebf7;
  display: flex;
  justify-content: space-around;
}

.ucenter_mains_div > div {
  border-radius: 25px;
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}

.span_i {
  /* margin-right: 80px; */
  text-align: left;
}

.span_i > img {
  margin-right: 20px;
  width: auto;
  height: 20px;
  object-fit: contain;
}

.tac {
  margin-right: -2px;
}

.ucenter_top_log {
  color: #edf3fc;
  padding: 20px 0 20px 0;
  font-size: 25px;
  font-weight: 600;
}

.ucenter_top_log > img {
  width: 190px;
}

.ucenter_mains_div_A {
  background-color: #e4ebf7;
  /* height: 100vh; */
  width: 70%;
}

.ucenter_mains_div_A_divS {
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  height: 490px;
  margin-top: 10px;
}

.ucenter_mains_div_A_divS > div {
  width: 100%;
  height: 240px;
  display: flex;
  /* justify-content: center; */
  /* background-color: #1f2738; */
  /* float: left; */
}

.ucenter_mains_div_A_divS_divs {
  display: flex;
  justify-content: space-around;
}

.ucenter_mains_div_A_divS_divs_div {
  width: 48%;
  background-color: #edf3fc;
  border-radius: 15px;
  /* margin-top: 5px; */
  /* margin-right: 10px; */
  padding: 10px;
}

.ucenter_mains_div_A_divS_divs_div_divA {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  margin-top: 20px;
}

.ucenter_mains_div_A_divS_divs_div_divB {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 117px;
  position: relative;
  padding: 0 30px 0 50px;
}

.ucenter_mains_div_A_divS_divs_div_divC {
  height: 57px;
  border-top: 1px solid #edf2f6;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 3px;
}

.ucenter_mains_div_A_divS_divs_div_divA_img {
  /* background-color: #1a73e8; */
  display: flex;
  justify-content: center;
}

.ucenter_mains_div_A_divS_divs_div_divA_img > div {
  margin-top: 7px;
  font-weight: 500;
}

.ucenter_mains_div_A_divS_divs_div_divA_butt {
  background: #edf3fc;
  border: 1px solid #1a73e8;
  color: #1a73e8;
  font-size: 14px;
  padding: 5px 20px 5px 20px;
  border-radius: 8px;
}

.ucenter_mains_div_A_divS_divs_div_divC_buttS {
  width: 200px;
  padding: 5px 20px 5px 20px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.ucenter_mains_div_A_divS_divs_div_divC_butt {
  width: 95px;
  height: 28px;
  background: #f0f9ff;
  border-radius: 4px;
  border: 1px solid #d9e4fa;
  text-align: center;
  line-height: 21px;
  box-sizing: border-box;
  font-size: 14px;
  color: #183caa;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ucenter_mains_div_A_divS_divs_div_divB_H {
  font-size: 24px;
  font-weight: 600;
  font-family: SourceHanSansCN-Bold;
  color: #151d48;
}

.ucenter_mains_div_A_divS_divs_div_divB_text {
  font-size: 14px;
  font-weight: 400;
  color: #96a5b8;
}

.ucenter_mains_div_A_divB {
  width: 100%;
  height: 400px;
  background-color: #edf3fc;
  border-radius: 12px;
  margin-top: 10px;
}

.ucenter_mains_div_B {
  margin-top: 10px;
  background-color: #edf3fc;
  width: 29%;
}

.ucenter_mains_div_B_divA {
}

.ucenter_mains_div_B_divB {
}

.ucenter_mains_div_B_divA_name {
  font-size: 18px;
  font-family: Manrope-Bold, Manrope;
  font-weight: 700;
  color: #23262f;
  line-height: 40px;
  text-align: left;
}

.ucenter_mains_div_B_divA_ponth {
  font-size: 14px;
  font-family: Manrope-SemiBold, Manrope;
  font-weight: 600;
  color: #787486;
  line-height: 16px;
  text-align: left;
  margin-top: 3px;
}

.ucenter_mains_div_B_divA_div {
  margin: 10px;
  padding-top: 50px;
  padding-bottom: 50px;
  border: 1px solid #dfdcdc;
  border-radius: 5px;
}

.ucenter_mains_div_B_divA_div > div {
  display: flex;
  justify-content: center;
}

.ucenter_mains_div_B_divA_type {
  font-size: 14px;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  color: #737791;
  line-height: 16px;
  text-align: left;
}

.log_text {
  /* font-size: 65px; */
  font-weight: 600;
  color: #05697a;
}

.log_text > img {
  width: 90px;
  height: 90px;
}

.log_user {
  margin-left: 20px;
  margin-top: 5px;
}

.butt_ucenter_butts {
  font-size: 14px;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  color: #183caa;
  width: 88px;
  height: 36px;
  background: #f0f9ff;
  border: 1px solid #d9e4fa;
  border-radius: 22px 22px 22px 22px;
  line-height: 36px;
  text-align: center;
  margin: 20px auto 0;
  display: block;
}

.ucenter_div_text_A {
  font-size: 12px;
  font-weight: 400;
  color: #869ebb;
  margin-top: 19px;
  text-align: center;
}

.ucenter_div_text {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.ucenter_mains_div_B_divA_div_HA {
  font-size: 16px;
  /* font-family: SourceHanSansCN-Medium; */
  color: #0e0b3d;
  text-align: left;
}

.ucenter_mains_div_B_divA_div_HA_divs {
  margin-top: 20px;
}

.el-icon-medal-1 {
  font-size: 28px;
  margin-right: 10px;
}

.ucenter_mains_div_B_divA_div_HA_divs_top {
  height: 38px;
  border-radius: 4px;
  background: #f8faff;
  box-sizing: border-box;
  padding-left: 20px;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #18181b;
  font-family: SourceHanSansCN-Medium;
  margin-bottom: 6px;
}

.ucenter_mains_div_B_divA_div_HA_divs_text {
  width: 300px;
  font-size: 14px;
  color: #8c9db2;
  line-height: 20px;
  padding-left: 5px;
  text-align: left;
}

.ucenter_mains_div_A_divA_div {
  padding-left: 40px;
  margin: 10px;
  padding-top: 50px;
  padding-bottom: 50px;
  border: 1px solid #dfdcdc;
  border-radius: 5px;
  height: 400px;
  overflow-y: auto;
  /* border: 3px solid #01ad75; */
}

.ucenter_mains_div_B_divA_div_HA_divs:nth-child(2)
> .ucenter_mains_div_B_divA_div_HA_divs_top {
  background: #edfbf7;
  color: #01ad75;
}

.ucenter_mains_div_B_divA_div_HA_divs:nth-child(3)
> .ucenter_mains_div_B_divA_div_HA_divs_top {
  background: #fffaf8;
  color: #ff6d38;
}

.ucenter_mains_div {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap; /* 允许换行 */
}

.echart-iframe {
  width: 100%;
  height: 400px; /* 可根据需要调整高度 */
  border: none;
  background-color: #edf3fc;
}

</style>


